import { useCallback } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useDownloader } from '@trinity/chat-components/hooks/useDownloader';

export type IconnectArtifactDownloadParams = {
  draftId: string;
  dashboardImageBase64?: string;
};

const sanitizeDashboardImageDataUrl = (dataUrl: string | undefined): string | undefined => {
  if (!dataUrl) {
    return undefined;
  }

  const trimmed = dataUrl.trim();
  if (!trimmed || trimmed === 'data:,' || trimmed === 'data:') {
    return undefined;
  }

  if (!trimmed.startsWith('data:image/')) {
    return undefined;
  }

  return trimmed;
};

export function useIconnectArtifactDownloader() {
  const apiClient = useChatApiClient();
  const downloader = useDownloader();

  return useCallback(
    async (params: IconnectArtifactDownloadParams) => {
      const dashboardImageBase64 = sanitizeDashboardImageDataUrl(params.dashboardImageBase64);

      const result = await apiClient.chatInstances.downloadIconnectArtifact({
        draftId: params.draftId,
        dashboardImageBase64,
      });

      downloader({ blob: result.blob, filename: result.filename });
    },
    [apiClient, downloader]
  );
}
